import SelectComponent, {SelectComponentComponentProps, SelectComponentReduxProps} from "../../ui/select/SelectComponent";
import LeadStatus from "../../../model/lead/LeadStatus";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";

class SelectLeadStatus extends SelectComponent<LeadStatus> {

	matchFilter(element: LeadStatus, filter: string): boolean {
		return element.getStatusLabel().indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: LeadStatus): string {
		return element.id;
	}

	elementToString(element: LeadStatus): string {
		return element.getStatusLabel();
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.leadStatus.leadStatuses
	}
}

export default connect<SelectComponentReduxProps<LeadStatus>, SelectComponentComponentProps<LeadStatus>>(
	mapStateToProps)(SelectLeadStatus)
